const routes = [
    {
        path: "/instructor/exam/schedule",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "examschedule_instructorexamschedule"
        }
    }
];

export default routes;
